
import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Investor, Contact } from "@/types/investor";
import { ExternalLink, Mail } from "lucide-react";

interface ContactTableRowProps {
  contact: Contact;
  investor: Investor | undefined;
  isProcessed: boolean;
}

const ContactTableRow = ({ contact, investor, isProcessed }: ContactTableRowProps) => {
  return (
    <TableRow className="hover:bg-muted/50">
      <TableCell>
        <div className="space-y-1">
          <div className="font-medium">{contact.name}</div>
          <div className="text-sm text-muted-foreground">{contact.role}</div>
        </div>
      </TableCell>
      
      <TableCell>
        <div className="space-y-1">
          <div className="font-medium">{contact.firmName}</div>
          {investor && (
            <Badge variant={isProcessed ? "success" : "secondary"} className="text-xs">
              {isProcessed ? "Processed" : "Not Processed"}
            </Badge>
          )}
        </div>
      </TableCell>
      
      <TableCell>
        <div className="space-y-1">
          {contact.email && (
            <div className="text-sm">{contact.email}</div>
          )}
          {contact.phone && (
            <div className="text-sm text-muted-foreground">{contact.phone}</div>
          )}
        </div>
      </TableCell>
      
      <TableCell>
        <div className="text-sm text-muted-foreground">
          {contact.location || "Not specified"}
        </div>
      </TableCell>
      
      <TableCell>
        <div className="text-sm text-muted-foreground">
          -
        </div>
      </TableCell>
      
      <TableCell>
        <div className="flex items-center gap-2">
          {contact.email && (
            <Button size="sm" variant="outline">
              <Mail className="h-4 w-4" />
            </Button>
          )}
          {contact.linkedin && (
            <Button 
              size="sm" 
              variant="outline"
              onClick={() => window.open(contact.linkedin, '_blank')}
            >
              <ExternalLink className="h-4 w-4" />
            </Button>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ContactTableRow;
